// extracted by mini-css-extract-plugin
export default {"shared_table_container":"table_shared_table_container__DqUET","padding_16_20":"table_padding_16_20__Tq4bA","padding_20":"table_padding_20__GPHgK"};